export enum SlugType {
  Cities = 'cities',
  Categories = 'categories',
  MarketingPages = 'marketing_pages'
}